import { createDataNode } from '../nodeFactory/dataNodeUtils'
import type { OOICssConfig, TPAWidgetDefinition } from '@wix/thunderbolt-becky-types'
import { envRefs } from '../refs/refsFactory'
import type { WidgetData } from '@wix/thunderbolt-symbols'
import type { Ref } from '@wix/thunderbolt-types'
import type { BeckyModel } from '@wix/thunderbolt-becky-root'

export const TPAWidget = createDataNode<
	TPAWidgetDefinition['data'],
	{
		cssConfig: Ref<OOICssConfig>
		widgetSpecData: Ref<WidgetData[string]>
		appSettings: Ref<object | undefined>
		migratingToOoiWidgetIds: Ref<BeckyModel['migratingToOoiWidgetIds']>
		cssPerBreakpointWidgetIds: Ref<BeckyModel['cssPerBreakpointWidgetIds']>
	}
>({
	getDependencies: (dataItem: TPAWidgetDefinition['data']) => {
		return {
			cssConfig: envRefs.ooiCssConfig(dataItem.widgetId),
			widgetSpecData: envRefs.widgetSpecData(dataItem.appDefinitionId, dataItem.widgetId),
			appSettings: envRefs.ooiWidgetsAppSettings(dataItem.widgetId, dataItem.referenceId),
			migratingToOoiWidgetIds: envRefs.migratingToOoiWidgetIds,
			cssPerBreakpointWidgetIds: envRefs.cssPerBreakpointWidgetIds,
		}
	},
	toViewItem: (
		dataItem: TPAWidgetDefinition['data'],
		resolvedRefs: null | object,
		{ migratingToOoiWidgetIds, cssPerBreakpointWidgetIds, ...restDeps }
	) => {
		const isMigratingToOoi = migratingToOoiWidgetIds.includes(dataItem.widgetId)
		const isCssPerBreakpoint = cssPerBreakpointWidgetIds.includes(dataItem.widgetId)
		const parseTpaData = (tpaData: string) => {
			try {
				return JSON.parse(tpaData)
			} catch (e) {
				console.error('Failed to parse tpaData!', e)
				return {}
			}
		}
		return {
			...dataItem,
			isMigratingToOoi,
			isCssPerBreakpoint,
			...restDeps,
			...(resolvedRefs ? resolvedRefs : {}),
			// @ts-ignore
			tpaData: resolvedRefs?.tpaData?.content ? parseTpaData(resolvedRefs.tpaData.content) : {},
		}
	},
})
